
export const setAnioSeleccionadoActions = (anio: number) => ({
    type: 'SET_ANIO',
    payload: anio,
});